// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const coalSeam = defineModel({
  id: "coal-seam",
  batchId: "future",
  name: "Coal seam",
  tags: ["scenery","coal","seam","low-poly","age-of-mcp","future"],
  summary: "A coal-bearing rock seam. Mined for coal — the basic fuel for smelters, kilns and forges.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: "#787b82", position: [-0.13, 0.21, 0], rotation: [0, 0.4, 0.06], scale: [1.05, 1, 1.05] },
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: "#83868d", position: [0.18, 0.18, 0.05], rotation: [0.08, 1.3, -0.12], scale: [0.95, 0.92, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#686b72", position: [0.02, 0.34, -0.12], rotation: [0.2, 0.9, 0.1] },
      { geometry: new THREE.TetrahedronGeometry(0.11, 0), color: "#1c1d20", position: [0, 0.12, 0.04], rotation: [0.3, 0.5, 0.2], scale: [1.1, 1, 0.9] },
      { geometry: new THREE.TetrahedronGeometry(0.1, 0), color: "#2c2d31", position: [0.03, 0.24, 0.06], rotation: [0.6, 1.4, 0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.09, 0), color: "#1c1d20", position: [-0.04, 0.18, 0.1], rotation: [0.2, 2.1, 0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#2c2d31", position: [0.06, 0.33, -0.02], rotation: [0, 1, 0], scale: [1, 0.8, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#1c1d20", position: [-0.1, 0.28, 0], rotation: [0.4, 0.2, 0.6] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#1c1d20", position: [0.14, 0.04, 0.08], rotation: [0.3, 0.8, 0.2], scale: [1.2, 0.7, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#2c2d31", position: [-0.14, 0.04, -0.09], rotation: [0.5, 1.7, 0.4] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#1c1d20", position: [0.07, 0.03, -0.15], rotation: [0.2, 0.4, 0.3], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#686b72", position: [-0.16, 0.04, 0.05], rotation: [0.3, 1, 0.2], scale: [1.2, 0.7, 1] },
    ],
  animations: [],
});
